<template>
  <el-pagination
    style="margin-top:20px"
    background
    layout="sizes,prev,pager,next"
    :page-sizes="[10, 100, 200]"
    :page-size="pageData.showCount"
    :total="pageData.totalCount"
    :current-page.sync="pageData.currentPage"
    @current-change="handleCurrentChange"
    @size-change="handleSizeChange"
  ></el-pagination>
</template>

<script>
export default {
  name: "pagination",
  props: ["pageData"],
  methods: {
    handleCurrentChange(val) {
      this.$emit("updatePage", val);
      // console.log("updatePage", val);
      // <Page @updatePage="..." :pageData="..." />
    },
    handleSizeChange(val) {
      this.$emit("updateSize", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-pagination {
  margin: 10px 0;
}
</style>
